import { BasesOptions, ClientsEnv } from '@mamba/clients';
import localforage from 'localforage';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import Vue from 'vue';
import { UserAgent } from './userAgent';
// 持久化访问器
const LocalForage = localforage.createInstance({
  name: process.env.StorageKey,
  storeName: process.env.StorageKey,
});
BasesOptions.resetConfig({
  // storagePrefix: process.env.StorageKey,
  createStorage: lodash.constant({
    clear: LocalForage.clear,
    setItem: LocalForage.setItem,
    removeItem: LocalForage.removeItem,
    getItem: LocalForage.getItem,
  }),
});
@BindAll()
class AppConfig extends ClientsEnv {
  /**
   * 环境设备信息
   * @memberof AppConfig
   */
  readonly userAgent = new UserAgent();
  /**
   * 账号中心地址
   * @memberof AppConfig
   */
  readonly accountUrl = '/accountm/personal/';
  /**
   * 账号中心登录地址
   * @memberof AppConfig
   */
  readonly accountLoginUrl = '/accountm/oauth2/authorize/';
  /**
   * 账号中心存储key值
   * @memberof AppConfig
   */
  readonly accountKey = '_account__user';
  /**
   * 检查版本信息
   */
  async onInspectVersion() {
    const versionKey = this.createStorageKey('version');
    const versionVal = lodash.join([this.version, this.timestamp], '-');
    const version = await LocalForage.getItem(versionKey);
    // 清理 版本 不统一缓存
    if (!lodash.eq(version, versionVal)) {
      return this.onClear();
    }
  }
  /**
   * 清理缓存
   * @memberof ClientsEnv
   */
  async onClear() {
    const versionKey = this.createStorageKey('version');
    const versionVal = lodash.join([this.version, this.timestamp], '-');
    await LocalForage.clear();
    await LocalForage.setItem(versionKey, versionVal);
    return true;
  }
}
export const $AppConfig = new AppConfig();
Object.defineProperty(Vue.prototype, 'AppConfig', {
  get: lodash.constant($AppConfig),
});
declare module 'vue/types/vue' {
  interface Vue {
    AppConfig: AppConfig;
  }
}
declare module '@nuxt/types' {
  interface Context {
    /** 全局状态 */
    AppConfig: AppConfig;
  }
}
